import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { CREATE_QUESTIONNAIRE_RESPONSE } from '../../services/graphql/mutations/client';

type QuestionnaireInput = {
  assignmentId: number;
  name: string;
  answers: string;
}

export const useCreateQuestionnaireResponse = () => {
  const [createQuestionnaireResponse, { loading }] = useMutation(CREATE_QUESTIONNAIRE_RESPONSE);

  const createData = useCallback(async (values: QuestionnaireInput) => {
    try {
      const { data } = await createQuestionnaireResponse({
        variables: {
          input: {
            assignmentId: values.assignmentId,
            name: values.name,
            answers: values.answers
          },
        }
      });
      return data?.createQuestionnaireResponse;
    } catch (error: any) {
      console.log('Error in createQuestionnaireResponse: ', error?.graphQLErrors[0].message);
    }
  }, [createQuestionnaireResponse]);

  return {
    create: createData,
    loading
  };
};